module.exports = __webpack_public_path__ + "static/img/backups.60601c06.png";